import { form } from '../../../../formState'

export function useValues() {
  const includeMessageField = form.useFormField('includeMessageUnsubscriptionInstructions')
  const includeMessage = includeMessageField.field.value

  const notificationWayField = form.useFormField('notificationWay')
  const notificationWay = notificationWayField.field.value

  return { showWarningCard: !includeMessage, notificationWay }
}
